import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { FILTER_ORDER_TYPE } from 'Defaults/filters'
import { SL_GATE } from 'Defaults/modals'
// import { SCHOOL_ALERT_COMING_SOON_MESSAGE } from 'Defaults/school'
// import PopupMessage from 'Components/PopupMessage'
import SvgIcon from 'Components/SvgIcon'

import { selectedFilterCountHook } from '../FiltersView/FilterView'
// import css from './styles.css'
import RenderFilterSection from '../RenderFilterSection'
import {
  _FilterBarContainer,
  _MoreFilterAlertContainer,
  _MoreFilterBtn,
  _SaveAlertBtn,
  _SpecialFilterContainer,
  _BasicFilter,
  _Separator,
  _FilterCount,
  _FilterCountText,
  // _SchoolMessage,
} from './styles'

const FilterSaveSearchBar = ({
  userIsAuthentificated,
  openModal,
  googleAnalyticsEvent,
  setMobileFilterButtonState,
  filterButtonActive,
  filterLookup,
  offer,
  lastSearchObj,
  startShowOnMobile,
  alertId,
  filterOrders,
  basicFilterKeys,
  specialFilterKeys,
  dockIsOpen,
  isArchive,
  schoolDetail,
  schoolEnabled,
}) => {
  // const [alertBtnHovered, setHovered] = useState(false)
  const filterCount = selectedFilterCountHook({
    basicFilterKeys,
    specialFilterKeys,
    filterLookup,
    lastSearchObj,
    filterOrders,
    startShowOnMobile,
  })
  const moreFiltersClick = useCallback(() => {
    googleAnalyticsEvent({
      category: 'search',
      action: [
        'More filters',
        `${filterButtonActive ? 'close' : 'open'}`,
      ],
    })
    setMobileFilterButtonState(!filterButtonActive)
  }, [filterButtonActive])

  const disableAlert = schoolEnabled && (schoolDetail?.boundary?.type === 'MultiPolygon')
  const isPrecon = offer?.toLowerCase() === 'precon'
  return (
    <_FilterBarContainer
      dockIsOpen={dockIsOpen}
      filterButtonActive={filterButtonActive}
      justify={'space-around'}
      align={'center'}
      isArchive={isArchive}
      isPrecon={isPrecon}
    >
      {
        !startShowOnMobile ?
          <>
            <_SpecialFilterContainer isArchive={isArchive}>
              <RenderFilterSection
                isBasic
                offer={offer}
                orderType={FILTER_ORDER_TYPE.SPECIAL}

              />
              {
                !isArchive && (
                  <_BasicFilter data-test-id="basicFilters">
                    <RenderFilterSection
                      isBasic
                      offer={offer}
                      orderType={FILTER_ORDER_TYPE.BASIC}
                    />
                  </_BasicFilter>
                )
              }

            </_SpecialFilterContainer>


            <_MoreFilterAlertContainer>
              <_MoreFilterBtn
                data-test-id={'moreFilters'}
                small
                secondary
                active={filterButtonActive}
                filterSelected={filterCount}
                onClick={moreFiltersClick}
              >
                {!filterButtonActive && !filterCount ? (
                  <SvgIcon name="#icon-dropdown-arrow" width={12} height={12} />
                ) : null}
                <span data-test-id="filterBtnLabel">
                  {filterButtonActive ? 'Close' : 'More'} Filters
                </span>
                {filterCount ? (
                  <_FilterCount center>
                    <_Separator>|</_Separator>
                    <_FilterCountText active={filterButtonActive}>
                      {filterCount}
                    </_FilterCountText>
                  </_FilterCount>
                ) : (
                  ''
                )}
              </_MoreFilterBtn>
              <div>
                {!alertId && !isPrecon && (
                <_SaveAlertBtn
                  disabled={disableAlert}
                  small
                  primary
                  gate={SL_GATE.AREA_ALERT}
                  userIsAuthentificated={userIsAuthentificated}
                  googleAnalyticsEvent={googleAnalyticsEvent}
                  openModal={openModal}
                  schoolDetail={schoolDetail}
                  schoolEnabled={schoolEnabled}
                >
                  <SvgIcon name="#icon-alert" width={16} height={16} />
                  <span>Get Alerts</span>
                </_SaveAlertBtn>
                )}
              </div>
            </_MoreFilterAlertContainer>

          </>
          : ''
      }
    </_FilterBarContainer>
  )
}

FilterSaveSearchBar.propTypes = {
  userIsAuthentificated: PropTypes.bool,
  openModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  lastSearchObj: PropTypes.shape({}),
  setMobileFilterButtonState: PropTypes.func,
  filterButtonActive: PropTypes.bool,
  dockIsOpen: PropTypes.bool,
  startShowOnMobile: PropTypes.bool,
  filterLookup: PropTypes.shape({}),
  alertId: PropTypes.string,
  schoolDetail: PropTypes.shape({
    boundary: PropTypes.shape({
      type: PropTypes.string,
      coordinates: PropTypes.array,
    }),
  }),
  // modeType: PropTypes.string,
  offer: PropTypes.string,
  isArchive: PropTypes.bool,
  filterOrders: PropTypes.shape({
    special: PropTypes.arrayOf(PropTypes.shape({})),
    basic: PropTypes.arrayOf(PropTypes.shape({})),
    advanced: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  basicFilterKeys: PropTypes.arrayOf(PropTypes.string),
  specialFilterKeys: PropTypes.arrayOf(PropTypes.string),
  schoolEnabled: PropTypes.bool,
}
export default FilterSaveSearchBar
